export enum Template {
  ADDI_BNPL_DEFAULT = 'ADDI_BNPL_DEFAULT',
  ADDI_BNPL_DEFAULT_LOCAL = 'ADDI_BNPL_DEFAULT_LOCAL', // TEMPLATE FOR BNPL (TEMPORAL CO)
  ADDI_BNPL_PROSPECT_DISCOUNT = 'ADDI_BNPL_PROSPECT_DISCOUNT',
  ADDI_BNPL_PROSPECT_DISCOUNT_LOCAL = 'ADDI_BNPL_PROSPECT_DISCOUNT_LOCAL',
  ADDI_TEMPLATE_02 = 'ADDI_TEMPLATE_02', // TEMPLATE FOR BNPL + BNPN
  ADDI_TEMPLATE_03 = 'ADDI_TEMPLATE_03', // TEMPLATE FOR EXPEDITED + BNPL
  ADDI_TEMPLATE_04 = 'ADDI_TEMPLATE_04', // TEMPLATE FOR EXPEDITED + BNPL + BNPN
  ADDI_TEMPLATE_4X = 'ADDI_TEMPLATE_4X', //

  // To ensure backwards compatibility temporarily
  ADDI_TEMPLATE_01 = 'ADDI_TEMPLATE_01', // TEMPLATE FOR BNPL
  ADDI_TEMPLATE_NC_DISC = 'ADDI_TEMPLATE_NC_DISC', // TEMPLATE FOR NEW CLIENT (PROSPECTS) DISCOUNTS

  ADDI_TEMPLATE_01_LOCAL = 'ADDI_TEMPLATE_01_LOCAL', // TEMPLATE FOR BNPL (TEMPORAL CO)
  ADDI_TEMPLATE_NC_DISC_LOCAL = 'ADDI_TEMPLATE_NC_DISC_LOCAL', // TEMPLATE FOR NEW CLIENT (PROSPECTS) DISCOUNTS (TEMPORAL CO)
}
